class ResourceStrings {
}
ResourceStrings.VOLTAGE = "Voltage";
ResourceStrings.PTOT = "Power Ptot";
ResourceStrings.QTOT = "Power Qtot";
ResourceStrings.THD = "THD";
ResourceStrings.THD_U = "THD (U)";
ResourceStrings.FLICKER = "Flicker";
ResourceStrings.UNBALANCE = "Unbalance";
ResourceStrings.USER_DEFINED = "User defined";
export default ResourceStrings;
